import { findIndex } from 'lodash'

export default {
    /* GET_ACCIDENTS
    ---------------------------------------------------------------
    */
    GET_ACCIDENTS_REQUEST: state => {
        state.accidentsLoading = true
    },
    GET_ACCIDENTS_SUCCESS: (state, data) => {
        state.accidents = data.results
        state.accidentsLoading = false
    },
    GET_ACCIDENTS_FAILURE: state => {
        state.accidentsLoading = false
    },

    /* CREATE_ACCIDENT
    ---------------------------------------------------------------
    */
    CREATE_ACCIDENT_REQUEST: state => {
        state.accidentLoading = true
    },
    CREATE_ACCIDENT_SUCCESS: (state) => {
        state.accidentLoading = false
    },
    CREATE_ACCIDENT_FAILURE: state => {
        state.accidentLoading = false
    },

    /* UPDATE_ACCIDENT
    ---------------------------------------------------------------
    */
    UPDATE_ACCIDENT: (state, data) => {
        const index = findIndex(state.accidents, { 'id': data.id })

        state.accidents.splice(index, 1, data)
    },

    /* GET_ACCIDENT_TYPES
    ---------------------------------------------------------------
    */
    GET_ACCIDENT_TYPES: (state, data) => {
        state.accidentTypes = data
    },

    /* GET_ACCIDENT_STATUSES
    ---------------------------------------------------------------
    */
    GET_ACCIDENT_STATUSES: (state, data) => {
        state.accidentStatuses = data
    },

    /* GET_MACHINES
    ---------------------------------------------------------------
    */
    GET_MACHINES: (state, data) => {
        state.machines = data
    },

    /* GET_ACCIDENT_DEPARTMENTS
    ---------------------------------------------------------------
    */
    GET_ACCIDENT_DEPARTMENTS: (state, data) => {
        state.accidentDepartments = data
    },

    /* GET_USER_ACCIDENT_DEPARTMENTS
    ---------------------------------------------------------------
    */
    GET_ACCIDENT_USER_DEPARTMENTS: (state, data) => {
        state.accidentUserDepartments = data
    },

    /* ACCIDENTS_FILTERS
    ---------------------------------------------------------------
    */
    SET_ACCIDENTS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_ACCIDENTS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}